"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ModalContextProvider = exports.ModalContextConsumer = exports.ModalContext = exports.defaultModalContext = void 0;

var _react = require("react");

var _emptyFunction = _interopRequireDefault(require("react-utils/emptyFunction"));

var defaultModalContext = {
  use: 'default',
  headerCallback: _emptyFunction.default
};
exports.defaultModalContext = defaultModalContext;
var ModalContext = (0, _react.createContext)(defaultModalContext);
exports.ModalContext = ModalContext;
var Consumer = ModalContext.Consumer,
    Provider = ModalContext.Provider;
exports.ModalContextProvider = Provider;
exports.ModalContextConsumer = Consumer;